import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { COMPANY_ASSOCIATED } from 'voxloud-types/dist/models/reviews';

@Component({
  selector: 'gdp-select-company-associated',
  templateUrl: './select-company-associated.component.html',
  styleUrls: ['./select-company-associated.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectCompanyAssociatedComponent),
      multi: true
    }
  ]
})
export class SelectCompanyAssociatedComponent implements ControlValueAccessor {
  public COMPANY_ASSOCIATED: string[] = COMPANY_ASSOCIATED;
  public selectedCompanyAssociated: string = this.COMPANY_ASSOCIATED[1];

  onChange: any = () => { }
  onTouch: any = () => { }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(val: string) {
    if (val) {
      this.selectedCompanyAssociated = val;
    }
  }

  public selectCompanyAssociated(value: string) {
    this.selectedCompanyAssociated = value;
    this.onChange(value);
  }

}
